/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export type DocumentResult = ServiceResult & {
  documentName?: string;
  result?: File;
};

export interface GroupScoreList {
  name?: string;
  isTenthScore?: boolean;
  scoreListItems?: GroupScoreListItem[];
}

export interface GroupScoreListItem {
  /** @format int32 */
  rank?: number;
  name?: string;
  /** @format double */
  score?: number;
  city?: string;
  organization?: string;
  organizationNumber?: string;
  field?: string;
  scoreListItems?: ScoreListItems[];
}

export interface Organization {
  name?: string;
  organizationNumber?: string;
}

export interface ScoreList {
  name?: string;
  isTenthScore?: boolean;
  scoreListItems?: ScoreListItems[];
}

export interface ScoreListDefinition {
  /** @format int32 */
  id?: number;
  name?: string;
  hasGroup?: boolean;
  isSection?: boolean;
}

export interface ScoreListDisciplineDefinition {
  /** @format int32 */
  disciplineId?: number;
  name?: string;
  scoreListDefinitions?: ScoreListDefinition[];
  scoreListFieldDefinitions?: ScoreListFieldDefinition[];
}

export interface ScoreListFieldDefinition {
  /** @format int32 */
  id?: number;
  name?: string;
}

export interface ScoreListItems {
  /** @format int32 */
  rank?: number;
  name?: string;
  licenseNumber?: string;
  /** @format double */
  score?: number;
  weaponName?: string;
  city?: string;
  organization?: string;
  organizationNumber?: string;
  ageCategory?: string;
  /** @format int32 */
  age?: number;
  /** @format int32 */
  birthyear?: number;
  field?: string;
}

export interface SectionScoreList {
  name?: string;
  sectionScoreListItems?: SectionScoreListItem[];
}

export interface SectionScoreListItem {
  /** @format int32 */
  rank?: number;
  organizationName?: string;
  organizationCity?: string;
  organizationNumber?: string;
  /** @format int32 */
  organizationCategory?: number;
  /** @format double */
  resultat?: number;
  /** @format int32 */
  participantCount?: number;
  /** @format int32 */
  minimalMandatoryParticipantCount?: number;
  /** @format int32 */
  mandatoryParticipantCount?: number;
  /** @format int32 */
  nonMandatoryParticipantCount?: number;
}

export interface ServiceResult {
  successful?: boolean;
  errorCode?: string | null;
  errorObject?: any;
}

export type ServiceResult1 = ServiceResult & {
  result?: T | null;
};

export type T = object;

export interface TimeSlotReservationData {
  shootingRangeNumber?: string;
  /** @format int32 */
  distanceId?: number;
  times?: TimeSlotReservationDataTime[];
  /** @format date-time */
  createdDateTime?: string | null;
}

export interface TimeSlotReservationDataGroup {
  /** @format int32 */
  groupId?: number;
  groupName?: string;
  shootingProgramDefinitionName?: string;
  /** @format int32 */
  shootingProgramDefinitionId?: number | null;
  items?: TimeSlotReservationDataItem[];
}

export interface TimeSlotReservationDataItem {
  /** @format int32 */
  id?: number;
  isMorning?: boolean;
  /** @format int32 */
  durationMinutes?: number;
  /** @format int32 */
  stateId?: number;
  /** @format int32 */
  laneNumber?: number;
  allowedDisciplineIds?: number[];
  shootingProgramDefinitionName?: string | null;
  assignedOrganizationNumber?: string | null;
  assignedOrganizationName?: string | null;
  participantName?: string | null;
  /** @format int32 */
  assignedDisciplineId?: number | null;
}

export interface TimeSlotReservationDataTime {
  time?: string;
  isMorning?: boolean;
  groups?: TimeSlotReservationDataGroup[];
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      return data;
    });
  };
}

/**
 * @title Event API V2 Public
 * @version v2
 *
 * Event API V2 Public for handling Events
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags LiveData
     * @name PublicEventsLiveDataFileDetail
     * @request GET:/api/public/events/{winFireEventId}/LiveData/file/{fileId}
     */
    publicEventsLiveDataFileDetail: (fileId: number, winFireEventId: string, params: RequestParams = {}) =>
      this.request<File, ServiceResult | DocumentResult | ServiceResult1>({
        path: `/api/public/events/${winFireEventId}/LiveData/file/${fileId}`,
        method: "GET",
        format: "blob",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LiveData
     * @name PublicEventsLiveDataRangeurDataDetail
     * @request GET:/api/public/events/{winFireEventId}/LiveData/rangeurData/{shootingRangeNumber}/{distanceId}
     */
    publicEventsLiveDataRangeurDataDetail: (
      shootingRangeNumber: string,
      distanceId: number,
      winFireEventId: string,
      params: RequestParams = {},
    ) =>
      this.request<TimeSlotReservationData, ServiceResult | DocumentResult | ServiceResult1>({
        path: `/api/public/events/${winFireEventId}/LiveData/rangeurData/${shootingRangeNumber}/${distanceId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LiveOrganizations
     * @name PublicEventsLiveOrganizationsDetail
     * @request GET:/api/public/events/{winFireEventId}/LiveOrganizations/{disciplineId}
     */
    publicEventsLiveOrganizationsDetail: (disciplineId: number, winFireEventId: string, params: RequestParams = {}) =>
      this.request<Organization[], ServiceResult | DocumentResult | ServiceResult1>({
        path: `/api/public/events/${winFireEventId}/LiveOrganizations/${disciplineId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LiveOrganizations
     * @name PublicEventsLiveOrganizationsResultsDetail
     * @request GET:/api/public/events/{winFireEventId}/LiveOrganizations/{disciplineId}/results/{organizationNr}
     */
    publicEventsLiveOrganizationsResultsDetail: (
      disciplineId: number,
      organizationNr: string,
      winFireEventId: string,
      params: RequestParams = {},
    ) =>
      this.request<File, any>({
        path: `/api/public/events/${winFireEventId}/LiveOrganizations/${disciplineId}/results/${organizationNr}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LiveScorelists
     * @name PublicEventsLiveScorelistsDetail
     * @request GET:/api/public/events/{winFireEventId}/LiveScorelists
     */
    publicEventsLiveScorelistsDetail: (winFireEventId: string, params: RequestParams = {}) =>
      this.request<ScoreListDisciplineDefinition[], ServiceResult | DocumentResult | ServiceResult1>({
        path: `/api/public/events/${winFireEventId}/LiveScorelists`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LiveScorelists
     * @name PublicEventsLiveScorelistsDetail2
     * @request GET:/api/public/events/{winFireEventId}/LiveScorelists/{id}/{fieldId}
     * @originalName publicEventsLiveScorelistsDetail
     * @duplicate
     */
    publicEventsLiveScorelistsDetail2: (
      id: number,
      fieldId: number,
      winFireEventId: string,
      params: RequestParams = {},
    ) =>
      this.request<ScoreList, ServiceResult | DocumentResult | ServiceResult1>({
        path: `/api/public/events/${winFireEventId}/LiveScorelists/${id}/${fieldId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LiveScorelists
     * @name PublicEventsLiveScorelistsGroupDetail
     * @request GET:/api/public/events/{winFireEventId}/LiveScorelists/{id}/{fieldId}/group
     */
    publicEventsLiveScorelistsGroupDetail: (
      id: number,
      fieldId: number,
      winFireEventId: string,
      params: RequestParams = {},
    ) =>
      this.request<GroupScoreList, ServiceResult | DocumentResult | ServiceResult1>({
        path: `/api/public/events/${winFireEventId}/LiveScorelists/${id}/${fieldId}/group`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LiveScorelists
     * @name PublicEventsLiveScorelistsSectionDetail
     * @request GET:/api/public/events/{winFireEventId}/LiveScorelists/{id}/section
     */
    publicEventsLiveScorelistsSectionDetail: (id: number, winFireEventId: string, params: RequestParams = {}) =>
      this.request<SectionScoreList, ServiceResult | DocumentResult | ServiceResult1>({
        path: `/api/public/events/${winFireEventId}/LiveScorelists/${id}/section`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
}
